import React, { FC, ReactNode } from "react";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";

import { styles } from "./styles";

interface MobileCardHeaderProps {
  children: ReactNode;
  actions?: ReactNode;
}

const Header: FC<MobileCardHeaderProps> = ({ children, actions }) => (
  <Box sx={styles.headerContainer}>
    <Box sx={styles.headerLeft}>{children}</Box>
    {actions && <Box sx={styles.headerActions}>{actions}</Box>}
  </Box>
);

interface MobileCardSectionProps {
  children: ReactNode;
  divider?: boolean;
}

const Body: FC<MobileCardSectionProps> = ({ children, divider }) => (
  <>
    {divider && <Divider sx={{ my: 1.5 }} />}
    <Box>{children}</Box>
  </>
);

const Footer: FC<MobileCardSectionProps> = ({ children, divider }) => (
  <>
    {divider && <Divider sx={{ my: 1.5 }} />}
    <Box>{children}</Box>
  </>
);

interface MobileCardProps {
  children: ReactNode;
}

const MobileCard: FC<MobileCardProps> & {
  Header: typeof Header;
  Body: typeof Body;
  Footer: typeof Footer;
} = ({ children }) => (
  <ListItem>
    <Box sx={styles.cardInner}>{children}</Box>
  </ListItem>
);

MobileCard.Header = Header;
MobileCard.Body = Body;
MobileCard.Footer = Footer;

export default MobileCard;
